import { Link } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';

import { TextLine, TextLines } from 'core/elements';
import { formatDate, getAgGridTableCellData } from 'core/utils';
import { CostSourceHelper } from 'pricing/helpers';
import { QuotePartColId } from 'quotes/components/QuotePartList';
import { oldQuotePartListPath } from 'quotes/routes/routePaths';

const VendorQuoteCell = (props: ICellRendererParams) => {
  const data = getAgGridTableCellData(props, QuotePartColId.VENDOR_QUOTE);
  if (!data) {
    return <TextLine text={props?.value} bold />;
  }

  const isGroupedByColumn = QuotePartColId.VENDOR_QUOTE === props?.node?.rowGroupColumn?.getColId();

  const vendorQuoteNumber = CostSourceHelper.getVendorQuoteNumber(data);

  const isVendorQuoteNumberCustom = !!data?.costSourceVendorQuoteNumber;

  const vendorQuoteUrl =
    vendorQuoteNumber && !isVendorQuoteNumberCustom
      ? oldQuotePartListPath(data?.costSourceQuoteId)
      : null;

  const vendorQuoteNumberElement = vendorQuoteUrl ? (
    <Link href={vendorQuoteUrl}>{vendorQuoteNumber}</Link>
  ) : (
    <>{vendorQuoteNumber}</>
  );

  if (isGroupedByColumn) {
    return <TextLine text={vendorQuoteNumberElement} bold textEllipsis />;
  }

  const extras = [];
  const externalProjectName = data?.costSourceQuoteExternalProjectName;
  if (externalProjectName) {
    extras.push(externalProjectName);
  }

  // The shared validity columns also hold a selected SPA's end date, which is not a vendor quote's.
  const vendorQuoteValidUntil = data?.costSourceQuoteValidUntil || data?.costSourceValidUntil;
  if (vendorQuoteNumber && vendorQuoteValidUntil) {
    extras.push(formatDate(vendorQuoteValidUntil));
  }

  return (
    <>
      <TextLine text={vendorQuoteNumberElement} bold textEllipsis />

      <TextLines texts={extras} isSubText textEllipsis />
    </>
  );
};

export default VendorQuoteCell;
